import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { baseurImage } from "../../Baseurl";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { updateProfile, setUser } from "../../store/userSlice";

export default function EditProfile() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.user.loading);
  const user = useSelector((state) => state.user.user);

  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);

  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    dateOfBirth: "",
    gender: "",
    role: "",
    personalPhoto: "",
  });

  useEffect(() => {
    if (user) {
      setForm({
        fullName: user.fullName || "",
        email: user.email || "",
        phoneNumber: user.phoneNumber || "",
        dateOfBirth: user.dateOfBirth
          ? new Date(user.dateOfBirth).toISOString().split("T")[0]
          : "",
        gender: user.gender || "",
        role: user.role || "",
        personalPhoto: user.personalPhoto || "",
      });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };
  const triggerFilePick = () => {
    fileInputRef.current?.click();
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    const resultAction = await dispatch(updateProfile({ form, file }));

    if (updateProfile.fulfilled.match(resultAction)) {
      // Ensure immediate UI update: if a new image was selected, set it as Blob in Redux
      if (file) {
        dispatch(setUser({ ...resultAction.payload, personalPhoto: file }));
      } else {
        dispatch(setUser(resultAction.payload));
      }

      try {
        localStorage.setItem("profilePhotoBust", String(Date.now()));
        window.dispatchEvent(new CustomEvent("profile-updated"));
      } catch {}

      Swal.fire({
        title: "Success!",
        text: "Profile updated successfully!",
        icon: "success",
        confirmButtonText: "View Profile",
        showCancelButton: true,
        cancelButtonText: "Stay Here",
      }).then((res) => {
        if (res.isConfirmed) {
          navigate("/Admin/myprofile");
        }
      });
    } else {
      const payload = resultAction.payload;
      const msg =
        typeof payload === "string"
          ? payload
          : payload?.message || "Failed to update profile";
      Swal.fire("Error", msg, "error");
    }
  };

  const name =
    user?.fullName || user?.shortName || user?.name || user?.username || "";

  const getPreviewImg = () => {
    if (file) {
      const url = URL.createObjectURL(file);
      setTimeout(() => URL.revokeObjectURL(url), 1000);
      return url;
    }
    const photo = form.personalPhoto;
    if (!photo) return "../assets/images/user/avatar-2.jpg";
    // Handle Blob/object
    if (typeof photo === "object" && photo instanceof Blob) {
      const url = URL.createObjectURL(photo);
      setTimeout(() => URL.revokeObjectURL(url), 1000);
      return url;
    }
    const bustKey = localStorage.getItem("profilePhotoBust") || Date.now();
    if (typeof photo === "string") {
      if (photo.startsWith("http://") || photo.startsWith("https://")) {
        return `${photo}?v=${bustKey}`;
      }
      return `${baseurImage}${photo}?v=${bustKey}`;
    }
    return "../assets/images/user/avatar-2.jpg";
  };

  return (
    <div className="pc-container">
      <div className="pc-content">
        <div className="row">
          {/* Left: User Image + Name */}
          <div className="col-lg-12" style={{ position: "relative" }}>
            <div className="myProfileImg">
              <img src={getPreviewImg()} alt="avatar" />
              <div className="profileEditIcon">
               
               
                  <i
				   onClick={triggerFilePick}
                    className="ti ti-edit f-20"
                    style={{ color: "rgb(70, 128, 255)", cursor: "pointer" }}
                  ></i>
               
                <input
                  ref={fileInputRef}
                  type="file"
                  name="personalPhoto"
                  onChange={handleFileChange}
                  className="d-none"
                  accept="image/*"
                />
              </div>
            </div>
            <div
              className="cardBorder table-card"
              style={{ marginTop: "85px" }}
            >
              <div className="tableHeader d-flex align-items-center justify-content-between">
                <h5>Edit Information</h5>
              </div>
			  <div className="p20">
            <div className="row">
              <form onSubmit={handleSubmit} encType="multipart/form-data">
                <div className="row">
                  <div className="col-md-6">
                    <label className="form-label">Full Name</label>
                    <input
                      type="text"
                      name="fullName"
                      value={form.fullName}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Email Address</label>
                    <input
                      type="email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Phone Number</label>
                    <input
                      type="text"
                      name="phoneNumber"
                      value={form.phoneNumber}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Date of Birth</label>
                    <input
                      type="date"
                      name="dateOfBirth"
                      value={form.dateOfBirth}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Gender</label>
                    <select
                      name="gender"
                      value={form.gender}
                      onChange={handleChange}
                      className="form-control"
                    >
                      <option value="">Select Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Role</label>
                    <input
                      type="text"
                      name="role"
                      value={form.role}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>

                  <div className="col-12 d-flex justify-content-end gap-2 mt-2">
                    <button
                      type="button"
                      className="cancelText"
                      onClick={() => navigate("/Admin/myprofile")}
                      disabled={loading}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="bgBtn"
                      disabled={loading}
                    >
                      {loading ? "Saving..." : "Save"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
            </div>
          </div>

          {/* Right: Form */}
          
        </div>
      </div>
    </div>
  );
}
